module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-70.801622e.woff2";